import { Link, useLocation } from 'react-router-dom'
import { Home, PawPrint, Users, ClipboardList, User, LogOut, LucideIcon } from 'lucide-react'
import logoSvg from '../../../assets/logo.svg'

interface NavItem {
  path: string
  label: string
  icon: LucideIcon
  exact?: boolean
}

interface SidebarProps {
  items?: NavItem[]
  userName?: string
  onLogout?: () => void
  className?: string
}

const defaultItems: NavItem[] = [
  { path: '/', label: 'Inicio', icon: Home, exact: true },
  { path: '/mascotas', label: 'Mascotas', icon: PawPrint },
  { path: '/grupo', label: 'Grupo', icon: Users },
  { path: '/bitacora', label: 'Bitácora', icon: ClipboardList },
  { path: '/perfil', label: 'Perfil', icon: User },
]

export function Sidebar({
  items = defaultItems,
  userName,
  onLogout,
  className = '',
}: SidebarProps) {
  const location = useLocation()

  const isActive = (item: NavItem) => {
    if (item.exact) {
      return location.pathname === item.path
    }
    return location.pathname === item.path || location.pathname.startsWith(item.path + '/')
  }

  return (
    <aside className={`sidebar ${className}`}>
      <div className="sidebar__header">
        <Link to="/" className="sidebar__logo">
          <img src={logoSvg} alt="" className="sidebar__logo-icon" />
          <span className="sidebar__logo-text">Rondela</span>
        </Link>
      </div>

      <nav className="sidebar__nav" aria-label="Navegación principal">
        {items.map((item) => {
          const Icon = item.icon
          const active = isActive(item)
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar__nav-item ${active ? 'sidebar__nav-item--active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </nav>

      <div className="sidebar__footer">
        {userName && <span className="sidebar__user">{userName}</span>}
        {onLogout && (
          <button className="sidebar__logout" onClick={onLogout} aria-label="Cerrar sesión">
            <LogOut size={18} />
            <span>Salir</span>
          </button>
        )}
      </div>
    </aside>
  )
}
